<template>
  <section class="d-flex flex-column">
    <v-card
      class="mt-4"
      style="background-color: transparent;"
      :style="{
        'border-left': `8px solid ${
          !transaction.have_an_proof_of_payment ? '#1976D2' : '#4CAF50'
        }`,
      }"
    >
      <v-row class="d-flex align-center mr-1 mr-md-0">
        <v-col cols="7" class="pl-1 pl-md-4 pr-0 pr-md-3">
          <v-card-text>
            <h6 class="text-subtitle-1 text-md-h6 font-weight-medium">
              {{ transaction.service }}
            </h6>
            <span class="grey--text text--darken-1"
              >Pedido {{ transaction.request_id }}</span
            >
          </v-card-text>
        </v-col>
        <v-col cols="5" class="px-2 px-md-8">
          <div class="d-flex flex-column text-end">
            <h6
              class="text-subtitle-1 text-md-h6 grey--text text--darken-1 font-weight-medium short-text"
            >
              $ {{ transaction.amount }}
            </h6>
            <span
              v-if="transaction.payment_day"
              style="text-wrap: nowrap"
              class="grey--text text--darken-1"
              >Cobrado el {{ transaction.payment_day | formatDateShort }}</span
            >
          </div>
        </v-col>
      </v-row>
    </v-card>
  </section>
</template>

<script>
export default {
  name: "BillServiceCard",
  props: {
    transaction: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.short-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
